import api, { handleApiResponse } from './api';
import {
  ApiResponse,
  Supplier,
  CreateSupplierRequest,
  UpdateSupplierRequest,
} from '../types';

export const supplierService = {
  // ==================== CREAR PROVEEDOR ====================

  /**
   * Crear nuevo proveedor
   * @param request - Datos del proveedor a crear
   * @returns Promise con el proveedor creado
   */
  async createSupplier(request: CreateSupplierRequest): Promise<Supplier> {
    const response = await api.post<ApiResponse<Supplier>>(
      '/suppliers',
      request,
    );
    return handleApiResponse(response);
  },

  // ==================== OBTENER PROVEEDORES ====================

  /**
   * Obtener todos los proveedores
   * @returns Promise con la lista de todos los proveedores
   */
  async getAllSuppliers(): Promise<Supplier[]> {
    const response = await api.get<ApiResponse<Supplier[]>>('/suppliers');
    return handleApiResponse(response);
  },

  /**
   * Obtener proveedor por ID
   * @param id - ID del proveedor a buscar
   * @returns Promise con el proveedor encontrado
   */
  async getSupplierById(id: number): Promise<Supplier> {
    const response = await api.get<ApiResponse<Supplier>>(`/suppliers/${id}`);
    return handleApiResponse(response);
  },

  // ==================== ACTUALIZAR PROVEEDOR ====================

  /**
   * Actualizar proveedor por ID
   * @param id - ID del proveedor a actualizar
   * @param request - Datos a actualizar
   * @returns Promise con el proveedor actualizado
   */
  async updateSupplier(
    id: number,
    request: UpdateSupplierRequest,
  ): Promise<Supplier> {
    const response = await api.put<ApiResponse<Supplier>>(
      `/suppliers/${id}`,
      request,
    );
    return handleApiResponse(response);
  },

  // ==================== ELIMINAR PROVEEDOR ====================

  /**
   * Eliminar proveedor por ID
   * @param id - ID del proveedor a eliminar
   * @returns Promise con la confirmación de eliminación
   */
  async deleteSupplier(id: number): Promise<void> {
    const response = await api.delete<ApiResponse<null>>(`/suppliers/${id}`);
    handleApiResponse(response);
  },
};
